import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import './DashBoard.css'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaChevronDown, FaSync, FaTimes, FaTrash, FaCrown, FaTelegram, FaGamepad, FaChartBar, FaGamepadAlt, FaMobile, FaVolumeUp, FaClock, FaCompress, FaExpand, FaCog} from 'react-icons/fa'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import BonusModal from './BonusModal'; 
import NewGamesAnnouncementPopup from './NewGamesAnnouncementPopup';
import PBingo2Dashboard from './Dashboard2';
import PrintCardsModal from './PrintCardsModal';
import { Button, Modal, Table, } from 'react-bootstrap';
import api from '../api';
import { useAuthValidation } from '../hooks/useAuthValidation';
const MySwal = withReactContent(Swal);


const DashboardPage = () => {
  const [dashboardVersion, setDashboardVersion] = useState(localStorage.getItem('dashboardVersion') || 'v1');
  const [bettingAmount, setBettingAmount] = useState(localStorage.getItem('bettingAmount') || '');
  const [audioLanguage, setAudioLanguage] = useState(localStorage.getItem('audioLanguage') || '');
  const [callSpeed, setCallSpeed] = useState(localStorage.getItem('callSpeed') || '');
  const [numberInput, setNumberInput] = useState('');
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [gameType, setGameType] = useState(localStorage.getItem('storedGameType') || 'regular');
  const [houseCardCount, setHouseCardCount] = useState(5);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [slideshowTables, setSlideshowTables] = useState([]);
  const [showHousePopup, setShowHousePopup] = useState(false);
  const [housePlayerCount, setHousePlayerCount] = useState(5);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [jackpotEnabled, setJackpotEnabled] = useState(false);
  const [jackpotContributionRate, setJackpotContributionRate] = useState(0.05);
  const [jackpotPool, setJackpotPool] = useState(0);
  const [showJackpotSettings, setShowJackpotSettings] = useState(false);
  
  const [isLoading, setIsLoading] = useState(false);
  const urlPh = window.location.href;
  const url = window.location.href;
  const inputRef = useRef(null);
  const [lastGames, setLastGames] = useState([]);
  const [showGameHistory, setShowGameHistory] = useState(false);
  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const [winningPattern, setWinningPattern] = useState(() => {
    try {
      const stored = localStorage.getItem('winningPattern');
      return stored ? JSON.parse(stored) : ['any'];
    } catch (error) {
      return ['any'];
    }
  }); 
  
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleNumberInput = (e) => {
    const value = e.target.value;
    if (!/^\d{0,3}$/.test(value)) return;
    setNumberInput(value);
  };

  const fetchLastFiveGames = async () => {
    try {
      const API = getApiUrl();
      const adminId = localStorage.getItem('adminId');
      const response = await api.get(`${API}/admin/${adminId}/last-games`); 
      setLastGames(response);
      setShowGameHistory(true);
    } catch (error) {
      console.error('Error fetching last games:', error);
    }
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const num = parseInt(numberInput);
      if (num >= 1 && num <= 100) {
        if (!selectedNumbers.includes(num)) {
          handleNumberSelect(num);
        }
        setNumberInput('');
      }
    }
  };

  const dropdownStyles = {
    dropdown: {
      position: 'relative',
      width: '100%'
    },
    button: {
      width: '100%',
      padding: '8px 12px',
      backgroundColor: '#475569',
      color: 'white',
      border: 'none',
      textAlign: 'left',
      cursor: 'pointer'
    },
    menu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#475569',
      border: '1px solid #374151',
      borderTop: 'none',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000
    },
    option: {
      padding: '8px 12px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#374151'
      }
    },
    checkbox: {
      marginRight: '8px'
    }
  };

  const underwaterStyles = {
    container: {
      background: 'linear-gradient(180deg, #001B48 0%, #003B8E 50%, #001B48 100%)',
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
    },
    caustics: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'url("/caustics.svg")',
      opacity: 0.1,
      animation: 'caustics 8s linear infinite',
      mixBlendMode: 'screen',
    },
    card: {
      background: 'rgba(1, 22, 56, 0.7)',
      backdropFilter: 'blur(10px)',
      borderRadius: '20px',
      border: '1px solid rgba(72, 159, 255, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 27, 72, 0.3), inset 0 0 32px rgba(72, 159, 255, 0.1)',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    },
    numberButton: {
      background: 'rgba(72, 159, 255, 0.1)',
      border: '1px solid rgba(72, 159, 255, 0.2)',
      borderRadius: '12px',
      color: '#89CFF0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        background: 'rgba(72, 159, 255, 0.2)',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(72, 159, 255, 0.2)',
      },
    },
    selectedNumber: {
      background: 'rgba(72, 255, 255, 0.5)',
      border: '1px solid rgba(0, 255, 255, 0.4)',
      color: '#00FFFF',
      boxShadow: '0 0 15px rgba(0, 255, 255, 0.3)',
      animation: 'pulse 2s infinite',
    },
    input: {
      background: 'rgba(72, 159, 255, 0.1)',
      border: '1px solid rgba(72, 159, 255, 0.2)',
      borderRadius: '12px',
      color: '#89CFF0',
      padding: '12px 16px',
      width: '100%',
      transition: 'all 0.3s ease',
      '&:focus': {
        border: '1px solid rgba(0, 255, 255, 0.4)',
        boxShadow: '0 0 15px rgba(0, 255, 255, 0.2)',
      },
    },
  };
  
  const dropdownStylesLight = {
    dropdown: {
      position: 'relative',
      width: '100%'
    },
    button: {
      width: '100%',
      padding: '12px',
      backgroundColor: '#F9FAFB',
      color: '#374151',
      border: '1px solid #E5E7EB',
      borderRadius: '0.5rem',
      textAlign: 'left',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        borderColor: '#F59E0B'
      }
    },
    menu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#FFFFFF',
      border: '1px solid #E5E7EB',
      borderRadius: '0.5rem',
      marginTop: '0.25rem',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000,
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    option: {
      padding: '8px 12px',
      color: '#374151',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#F9FAFB'
      }
    },
    selectedOption: {
      backgroundColor: '#FEF3C7',
      color: '#92400E'
    }
  };

  const MultiSelectDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPatterns, setSelectedPatterns] = useState(() => {
      try {
        const stored = localStorage.getItem('winningPattern');
        return stored ? JSON.parse(stored) : ['any'];
      } catch (error) {
        return ['any'];
      }
    });
    const dropdownRef = useRef(null);
  
    const patterns = [
      { value: 'any', label: 'All Common Patterns' },
      { value: 'rows', label: 'Row' },
      { value: 'columns', label: 'Column' },
      { value: 'diagonals', label: 'Diagonal' },
      { value: 'corners', label: 'Four Corners' },
      { value: 'surroundingFree', label: 'Surrounding FREE' },
      { value: 'fullCard', label: 'Full House' },
      { value: 'lShape', label: 'L Shape' },
      { value: 'bothDiagonals', label: 'X Shape' },
      { value: 'tShape', label: 'T Shape' },
      { value: 'sevenShape', label: '7 Shape' },
      { value: 'innerSquare', label: 'Inner Square' },
      { value: 'diamond', label: 'Diamond' },
      { value: 'cPattern', label: 'C Shape' },
      { value: 'numberFour', label: '4 shape' },
      { value: 'hShape', label: 'H Shape' },
      { value: 'cross', label: ' + Shape' },
      { value: 'outerSquare', label: 'Square Shape' },
      { value: 'zPattern', label: 'Z Shape' },
    ];
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  
    const handlePatternToggle = (value) => {
      let newPatterns;
      
      if (value === 'any') {
        // If 'any' is selected, clear all other selections
        newPatterns = ['any'];
      } else {
        if (selectedPatterns.includes('any')) {
          // If 'any' was previously selected, remove it
          newPatterns = [value];
        } else {
          // Toggle the selected pattern
          newPatterns = selectedPatterns.includes(value)
            ? selectedPatterns.filter(p => p !== value)
            : [...selectedPatterns, value];
        }
        
        // If no patterns are selected, default to 'any'
        if (newPatterns.length === 0) {
          newPatterns = ['any'];
        }
      }

      setSelectedPatterns(newPatterns);
      localStorage.setItem('winningPattern', JSON.stringify(newPatterns));
      setWinningPattern(newPatterns);
    };

    const getDisplayText = () => {
      if (selectedPatterns.length === 0) return 'Select patterns';
      if (selectedPatterns.includes('any')) return 'All Common Patterns';
      return `${selectedPatterns.length} pattern${selectedPatterns.length > 1 ? 's' : ''} selected`;
    };
  
    return (
      <div ref={dropdownRef} style={dropdownStyles.dropdown}>
        <label className="block text-white mb-2">
          Winning Patterns
        </label>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          style={dropdownStyles.button}
        >
          {getDisplayText()}
        </button>
        {isOpen && (
          <div style={dropdownStyles.menu}>
            {patterns.map(({ value, label }) => (
              <div
                key={value}
                style={dropdownStyles.option}
                onClick={() => handlePatternToggle(value)}
              >
                <input
                  type="checkbox"
                  checked={selectedPatterns.includes(value)}
                  onChange={() => {}}
                  style={dropdownStyles.checkbox}
                />
                {label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const GlassMultiSelectDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPatterns, setSelectedPatterns] = useState(() => {
      try {
        const stored = localStorage.getItem('winningPattern');
        return stored ? JSON.parse(stored) : ['any'];
      } catch (error) {
        return ['any'];
      }
    });
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
  
    const patterns = [
      { value: 'any', label: 'All Common Patterns' },
      { value: 'rows', label: 'Row' },
      { value: 'columns', label: 'Column' },
      { value: 'diagonals', label: 'Diagonal' },
      { value: 'corners', label: 'Four Corners' },
      { value: 'surroundingFree', label: 'Surrounding FREE' },
      { value: 'fullCard', label: 'Full House' },
      { value: 'lShape', label: 'L Shape' },
      { value: 'bothDiagonals', label: 'X Shape' },
      { value: 'tShape', label: 'T Shape' },
      { value: 'sevenShape', label: '7 Shape' },
      { value: 'innerSquare', label: 'Inner Square' },
      { value: 'diamond', label: 'Diamond' },
      { value: 'cPattern', label: 'C Shape' },
      { value: 'numberFour', label: '4 shape' },
      { value: 'hShape', label: 'H Shape' },
      { value: 'cross', label: '+ Shape' },
      { value: 'outerSquare', label: 'Square Shape' },
      { value: 'zPattern', label: 'Z Shape' }
    ];
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const getDropdownPosition = () => {
      if (!buttonRef.current) return {};
      const rect = buttonRef.current.getBoundingClientRect();
      return {
        top: `${rect.bottom + window.scrollY + 8}px`,
        left: `${rect.left + window.scrollX}px`,
        width: `${rect.width}px`,
      };
    };
  
    const handlePatternToggle = (value) => {
      let newPatterns;
      
      if (value === 'any') {
        newPatterns = ['any'];
      } else {
        if (selectedPatterns.includes('any')) {
          newPatterns = [value];
        } else {
          newPatterns = selectedPatterns.includes(value)
            ? selectedPatterns.filter(p => p !== value)
            : [...selectedPatterns, value];
        }
        
        if (newPatterns.length === 0) {
          newPatterns = ['any'];
        }
      }
  
      setSelectedPatterns(newPatterns);
      localStorage.setItem('winningPattern', JSON.stringify(newPatterns));
      setWinningPattern(newPatterns);
    };
  
    const getDisplayText = () => {
      if (selectedPatterns.length === 0) return 'Select patterns';
      if (selectedPatterns.includes('any')) return 'All Common Patterns';
      return `${selectedPatterns.length} pattern${selectedPatterns.length > 1 ? 's' : ''} selected`;
    };
  
    return (
      <div className="glass-card p-2">
        <label className="block text-white/80 text-sm mb-2">
          Winning Patterns
        </label>
        <div className="relative">
          <button
            ref={buttonRef}
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className={`
              w-full px-4 py-3 glass-button text-white
              flex justify-between items-center
              transition-all duration-300 rounded-xl
              backdrop-blur-md bg-white/10
              ${isOpen ? 'shadow-lg ring-2 ring-purple-500/50' : ''}
            `}
          >
            <span>{getDisplayText()}</span>
            <svg
              className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
  
          {isOpen && createPortal(
            <div 
              ref={dropdownRef}
              className="fixed backdrop-blur-xl bg-black/50 border border-white/20 shadow-2xl rounded-xl overflow-hidden"
              style={{
                ...getDropdownPosition(),
                zIndex: 9999,
              }}
            >
              <div className="max-h-[300px] overflow-auto custom-scrollbar">
                {patterns.map(({ value, label }) => (
                  <div
                    key={value}
                    className={`
                      flex items-center px-2 py-2 cursor-pointer
                      transition-all duration-200
                      ${selectedPatterns.includes(value)
                        ? 'bg-gradient-to-r from-purple-500/80 to-blue-500/80 text-white'
                        : 'text-white hover:bg-white/10'
                      }
                    `}
                    onClick={() => handlePatternToggle(value)}
                  >
                    <div className="relative flex items-center">
                      <input
                        type="checkbox"
                        checked={selectedPatterns.includes(value)}
                        onChange={() => {}}
                        className="
                          appearance-none w-4 h-4 rounded
                          border border-white/30
                          checked:bg-gradient-to-r checked:from-purple-500/80 checked:to-blue-500/80
                          transition-all duration-200
                        "
                      />
                      <svg
                        className={`
                          absolute w-3 h-3 text-white pointer-events-none
                          transition-opacity duration-200
                          ${selectedPatterns.includes(value) ? 'opacity-100' : 'opacity-0'}
                        `}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="ml-3">{label}</span>
                  </div>
                ))}
              </div>
            </div>,
            document.body
          )}
        </div>
      </div>
    );
  };

  const MultiSelectDropdownLight = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPatterns, setSelectedPatterns] = useState(() => {
      try {
        const stored = localStorage.getItem('winningPattern');
        return stored ? JSON.parse(stored) : ['any'];
      } catch (error) {
        return ['any'];
      }
    });
    const dropdownRef = useRef(null);
  
    const patterns = [
      { value: 'any', label: 'All Common Patterns' },
      { value: 'rows', label: 'Row' },
      { value: 'columns', label: 'Column' },
      { value: 'diagonals', label: 'Diagonal' },
      { value: 'corners', label: 'Four Corners' },
      { value: 'surroundingFree', label: 'Surrounding FREE' },
      { value: 'fullCard', label: 'Full House' },
      { value: 'lShape', label: 'L Shape' },
      { value: 'bothDiagonals', label: 'X Shape' },
      { value: 'tShape', label: 'T Shape' },
      { value: 'sevenShape', label: '7 Shape' },
      { value: 'innerSquare', label: 'Inner Square' },
      { value: 'diamond', label: 'Diamond' },
      { value: 'cPattern', label: 'C Shape' },
      { value: 'numberFour', label: '4 shape' },
      { value: 'hShape', label: 'H Shape' },
      { value: 'cross', label: ' + Shape' },
      { value: 'outerSquare', label: 'Square Shape' },
      { value: 'zPattern', label: 'Z Shape' },
    ];
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
  
    const handlePatternToggle = (value) => {
      let newPatterns;
      
      if (value === 'any') {
        // If 'any' is selected, clear all other selections
        newPatterns = ['any'];
      } else {
        if (selectedPatterns.includes('any')) {
          // If 'any' was previously selected, remove it
          newPatterns = [value];
        } else {
          // Toggle the selected pattern
          newPatterns = selectedPatterns.includes(value)
            ? selectedPatterns.filter(p => p !== value)
            : [...selectedPatterns, value];
        }
        
        // If no patterns are selected, default to 'any'
        if (newPatterns.length === 0) {
          newPatterns = ['any'];
        }
      }

      setSelectedPatterns(newPatterns);
      localStorage.setItem('winningPattern', JSON.stringify(newPatterns));
      setWinningPattern(newPatterns);
    };

    const getDisplayText = () => {
      if (selectedPatterns.length === 0) return 'Select patterns';
      if (selectedPatterns.includes('any')) return 'All Common Patterns';
      return `${selectedPatterns.length} pattern${selectedPatterns.length > 1 ? 's' : ''} selected`;
    };
  
    return (
      <div ref={dropdownRef} style={dropdownStylesLight.dropdown}>
        <label className="block text-dark font-semibold mb-2">
          Winning Patterns
        </label>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          style={dropdownStylesLight.button}
        >
          {getDisplayText()}
        </button>
        {isOpen && (
          <div style={dropdownStylesLight.menu}>
            {patterns.map(({ value, label }) => (
              <div
                key={value}
                style={dropdownStylesLight.option}
                onClick={() => handlePatternToggle(value)}
              >
                <input
                  type="checkbox"
                  checked={selectedPatterns.includes(value)}
                  onChange={() => {}}
                  style={dropdownStylesLight.checkbox}
                />
                {label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const BubbleGenerator = () => {
    useEffect(() => {
      const createBubble = () => {
        const bubble = document.createElement('div');
        
        bubble.style.cssText = `
          position: absolute;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          pointer-events: none;
          animation: float 6s ease-in-out infinite;
          bottom: -20px;
        `;
        
        const size = Math.random() * 40 + 10;
        bubble.style.width = `${size}px`;
        bubble.style.height = `${size}px`;
        bubble.style.left = `${Math.random() * 100}%`;
        
        const container = document.querySelector('.underwater-casino');
        if (container) {
          container.appendChild(bubble);
          
          setTimeout(() => {
            bubble.remove();
          }, 4000);
        }
      };
  
      const interval = setInterval(createBubble, 500);
  
      const style = document.createElement('style');
      style.textContent = `
        @keyframes float {
          0% {
            transform: translateY(0) rotate(0);
            opacity: 0.8;
          }
          100% {
            transform: translateY(-100vh) rotate(360deg);
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        clearInterval(interval);
        style.remove();
      };
    }, []);
  
    return null;
  };
  
  const BubbleEffect = () => {
    return (
      <div className="absolute inset-0 pointer-events-none">
        <div className="bubble-sm" style={{
          left: '20%',
          animationDelay: '0s'
        }} />
        <div className="bubble-sm" style={{
          left: '70%',
          animationDelay: '0.5s'
        }} />
      </div>
    );
  };

  const tropicalParadiseStyles = {
    container: {
      background: 'linear-gradient(180deg, #00C6FB 0%, #1CB5E0 100%)',
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'url("/wave-pattern.svg")',
      opacity: 0.1,
      animation: 'wave 15s linear infinite',
    },
    card: {
      background: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(10px)',
      borderRadius: '30px',
      border: '2px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0 8px 32px rgba(0, 198, 251, 0.2)',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
        zIndex: 0,
      },
    },
    numberButton: {
      background: 'rgba(255, 255, 255, 0.9)',
      border: 'none',
      borderRadius: '15px',
      color: '#1CB5E0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        transform: 'translateY(-3px) rotate(3deg)',
        boxShadow: '0 10px 20px rgba(0, 198, 251, 0.2)',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-50%',
        left: '-50%',
        width: '200%',
        height: '200%',
        background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.3), transparent)',
        transform: 'rotate(45deg)',
        transition: 'all 0.6s',
      },
      '&:hover::before': {
        transform: 'rotate(45deg) translate(100%, 100%)',
      },
    },
    selectedNumber: {
      background: 'linear-gradient(45deg, #FF6B6B, #FFE66D)',
      color: 'white',
      transform: 'translateY(-3px) rotate(-3deg)',
      boxShadow: '0 10px 20px rgba(255, 107, 107, 0.3)',
    },
    startButton: {
      background: 'linear-gradient(45deg, #FF6B6B, #FFE66D)',
      color: 'white',
      border: 'none',
      borderRadius: '20px',
      padding: '16px 32px',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 20px 40px rgba(255, 107, 107, 0.4)',
      },
    },
  };

  const DashboardVersionToggle = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
      <div className="version-toggle-container mb-1 flex justify-between bg-gray-800 max-h-10 min-h-4">
        <div className="bg-gray-800 p-1 rounded-lg inline-flex shadow-md">
        <button 
          className="md:hidden w-full text-white p-1 flex justify-between items-center"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Version {dashboardVersion.slice(1)} 
          <FaChevronDown className={`transition-transform ${isExpanded ? 'rotate-180' : ''} ml-2`} />
        </button>
        <div className={`${isExpanded ? 'block' : 'hidden'} mx-4 md:block md:inline-flex gap-2`}>
          {['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8'].map((version) => (
            <button
            key={version}
            className={`
              px-2 py-0.25 rounded-sm text-sm transition-all duration-200 max-h-10 min-h-1
              ${dashboardVersion === version
                ? 'bg-gradient-to-r from-amber-400 to-yellow-500 text-black shadow-sm'
                : 'bg-gray-400 text-black hover:text-gray-400'
              }
            `}
            onClick={() => {
              setDashboardVersion(version);
              localStorage.setItem('dashboardVersion', version);
              setIsExpanded(false);
            }}
          >
            Version {version.slice(1)}
          </button>
          ))}
          </div>
        </div>
        <FullScreenButton />
        <div className="text-white text-3xl">ወኪልዎን ያነጋግሩ</div>
        <div className="flex justify-between items-center">
          <div className="phoenix-logo mr-4">
            <div className='flex space-x-2'> <FaCrown className="icon"/> <div className="phoenix-text">FAST <span className="bingo-text">BINGO</span></div></div>
          </div>
          <ProfileIcon onClick={handleProfileClick} className="text-end mr-4"/>
          <div>
            <button onClick={handleLogout} className=" bg-danger rounded-lg text-white hover:text-amber-400 transition-colors duration-200 max-h-10 min-h-6 p-1 mx-2">Logout</button>
          </div>
        </div>
      </div>
    );
  };

  useAuthValidation();

  useEffect(() => {

    const storedGameType = localStorage.getItem('gameType');
    if (storedGameType) {
      setGameType(storedGameType);
    }
  }, []);

  const handleGameTypeSelect = (type) => {
    setGameType(type);
    localStorage.setItem('gameType', type);
  };

  const getApiUrl = () => {
    const hashedApiVersion = localStorage.getItem('apiVersion');
    if (hashedApiVersion) {
      const version2Hash = CryptoJS.SHA256('2').toString();
      if (hashedApiVersion === version2Hash) {
        return 'https://phoenix-bingo-2.onrender.com/api'
      }
    }
    return process.env.REACT_APP_API;
  };
  const API = getApiUrl();

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const winningPatterns = {
    rows: [
      [1, 2, 3, 4, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 6, 7, 8, 9, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 12, 13, 14, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 17, 18, 19, 20, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    columns: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 7, 0, 0, 0, 0, 12, 0, 0, 0, 0, 17, 0, 0, 0, 0, 22, 0, 0, 0],
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0],
      [0, 0, 0, 4, 0, 0, 0, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 19, 0, 0, 0, 0, 24, 0],
      [0, 0, 0, 0, 5, 0, 0, 0, 0, 10, 0, 0, 0, 0, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    diagonals: [
      [1, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 25],
      [0, 0, 0, 0, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    corners: [
      [1, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 25]
    ],
    surroundingFree: [
      [0, 0, 0, 0, 0, 0, 7, 0, 9, 0, 0, 0, 0, 0, 0, 0, 16, 0, 18, 0, 0, 0, 0, 0, 0]
    ],
    fullCard: [
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
    ],
    lShape: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    bothDiagonals: [
      [1, 0, 0, 0, 5, 0, 7, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 19, 0, 21, 0, 0, 0, 25]
    ],
    tShape: [
      [1, 2, 3, 4, 5, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    sevenShape: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    innerSquare: [
      [0, 0, 0, 0, 0, 0, 7, 8, 9, 0, 0, 11, 12, 13, 0, 0, 16, 17, 18, 0, 0, 0, 0, 0, 0]
    ],
    diamond: [
      [0, 0, 3, 0, 0, 0, 7, 0, 9, 0, 11, 0, 13, 0, 15, 0, 17, 0, 19, 0, 0, 0, 23, 0, 0]
    ],
    cPattern: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    numberFour: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    hShape: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 16, 0, 0, 0, 20, 21, 0, 0, 0, 25]
    ],
    cross: [
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 11, 12, 13, 14, 15, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    outerSquare: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 10, 11, 0, 0, 0, 15, 16, 0, 0, 0, 20, 21, 22, 23, 24, 25]
    ],
    zPattern: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 22, 23, 24, 25]
    ]
  };

  useEffect(() => {
    const selectedPatternTypes = Array.isArray(winningPattern) ? winningPattern : JSON.parse(localStorage.getItem('winningPattern') || '["any"]');
    let patternsToShow = [];
    
    if (selectedPatternTypes.includes('any')) {
      const commonPatterns = ['rows', 'columns', 'diagonals', 'surroundingFree', 'corners'];
      patternsToShow = commonPatterns.map(key => winningPatterns[key][0]);
    } else {
      selectedPatternTypes.forEach(patternType => {
        if (winningPatterns[patternType]) {
          patternsToShow = [...patternsToShow, ...winningPatterns[patternType]];
        }
      });
    }
    
    if (patternsToShow.length === 0) {
      patternsToShow = [winningPatterns.rows[0]];
    }
    
    const tables = patternsToShow.map((pattern) => generateTable(pattern));
    setSlideshowTables(tables);
  }, [winningPattern]);
  
  const handleNumberSelect = (number) => {
    if (selectedNumbers.includes(number)) {
      const updatedNumbers = selectedNumbers.filter((n) => n !== number);
      setSelectedNumbers(updatedNumbers);
      localStorage.setItem('selectedNumbers', JSON.stringify(updatedNumbers));
    } else {
      setSelectedNumbers([...selectedNumbers, number]);
      const updatedNumbers = [...selectedNumbers, number];
      setSelectedNumbers(updatedNumbers);
      localStorage.setItem('selectedNumbers', JSON.stringify(updatedNumbers));
    }
  };

  const ReloadIcon = ({ onClick }) => {
    return (
      <FaSync
        className="reload-icon"
        size={20}
        color="gold"
        style={{ cursor: 'pointer' }}
        onClick={onClick}
      />
    );
  };

  const handleReloadNumbers = () => {
    const storedNumbers = localStorage.getItem('selectedNumbers');
    if (storedNumbers) {
      setSelectedNumbers(JSON.parse(storedNumbers));
    }
  };

  const handleStartGame = async () => {
    setIsLoading(true);
    let winningPatternsData;
    try {
      const storedPatterns = localStorage.getItem('winningPattern');
      winningPatternsData = storedPatterns ? JSON.parse(storedPatterns) : ['any'];
    } catch (e) {
      console.warn('Invalid winning pattern in localStorage, using default');
      winningPatternsData = ['any'];
    }
    
    try {  
      const response = await api.post(`${API}/game/start`, {
        bettingAmount: parseInt(bettingAmount),
        cardPaletteNumbers: selectedNumbers,
        callSpeed: parseInt(callSpeed),
        gameType: gameType,
        winningPatterns: JSON.parse(localStorage.getItem('winningPattern')),
        houseCardCount: gameType === 'house' ? parseInt(selectedNumbers.length) : undefined,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log(response);
      navigate('/game-in-progress', { state: { gameId: response.gameId, calledNumbers: response.calledNumbers, playingCards: response.playingCards, payoutToWinner: response.payoutToWinner, callSpeed, audioLanguage, gameType, 
        houseCards: response.houseCards, callsToWin: response.winningCalls,  winningCalls: response.winningCalls,
        winningCard: response.winningCard,
        houseWin: response.houseWin, gameType: response.gameType, baseAmount: response.baseAmount, totalBonusAmount: response.totalBonusAmount, commissionRate: response.commissionRate } });
    } catch (error) {
      console.error('Error starting the game:', error);
      if (error.response.status === 400 && error.response.data.message == 'Insufficient balance in wallet') {
        alert('Insufficient balance in wallet');
      }
    }finally {
      setIsLoading(false);
    }
  };

  const handleLocalStorage = () => {
      const speedToSet = (audioLanguage === 'oromo' || audioLanguage === 'male1' || audioLanguage === 'tig')  ? '3000' : callSpeed;
      localStorage.setItem('bettingAmount', bettingAmount);
      localStorage.setItem('callSpeed', speedToSet);
      localStorage.setItem('audioLanguage', audioLanguage);
      localStorage.setItem('winningPattern', JSON.stringify(winningPattern));
  };

  useEffect(() => {
    if (audioLanguage === 'oromo' || audioLanguage === 'male1' || audioLanguage === 'tig') {
        setCallSpeed('3000');
    } else if (audioLanguage !== 'oromo') {
      setCallSpeed('5000');
    }
  }, [audioLanguage]);
  
  const generateTable = (pattern) => {
    const cellSize = 25;
    const dotSize = 25;

    const getPatternName = (pattern) => {
      const patternNames = {
        rows: 'Row',
        columns: 'Column',
        diagonals: 'Diagonal',
        surroundingFree: 'Surrounding FREE',
        corners: 'Four Corners',
        fullCard: 'Full House',
        lShape: 'L Shape',
        bothDiagonals: 'Both Diagonals',
        tShape: 'T Shape',
        sevenShape: 'Seven Shape',
        innerSquare: 'Inner Square',
        diamond: 'Diamond',
        cPattern: 'C Pattern',
        numberFour: 'Number Four',
        hShape: 'H Shape',
        cross: 'Cross',
        outerSquare: 'Outer Square',
        zPattern: 'Z Pattern'
      };
      for (const [key, patterns] of Object.entries(winningPatterns)) {
        if (patterns.some(p => JSON.stringify(p) === JSON.stringify(pattern))) {
          return patternNames[key] || key.replace(/([A-Z])/g, ' $1').toLowerCase().replace(/^./, str => str.toUpperCase());
        }
      }
      return '';
    };
  
    const cells = [];
    for (let i = 0; i < 25; i++) {
      cells.push(
        <td
          key={i}
          style={{
            padding: '15px 22px',
            position: 'relative',
            width: `${cellSize}px`,
            height: `${cellSize}px`,
            backgroundColor: '#E2E8F0',
            border: '1px solid black',
          }}
        >
          <div
            className='text-center mx-auto'
            style={{
              width: `${dotSize}px`,
              height: `${dotSize}px`,
              backgroundColor: pattern[i] > 0 ? 'blue' : 'transparent',
              borderRadius: '50%',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          ></div>
        </td>
      );
    }

    const rows = [];
    for (let i = 0; i < 5; i++) {
      rows.push(
        <tr key={i}>
          {cells.slice(i * 5, (i + 1) * 5)}
        </tr>
      );
    }

    const headerCells = ['B', 'I', 'N', 'G', 'O'].map((letter, index) => (
      <th
        key={index}
        className='fw-bold text-center'
        style={{
          backgroundColor: ['#3B82F6', '#EF4444', '#F97316', '#22C55E', '#ffc900'][index],
          width: `${cellSize}px`,
          height: `${cellSize}px`,
          fontSize: '20px',
          border: '1px solid white',
          padding: '10px',
        }}
      >
        {letter}
      </th>
    ));

    return (
      <div>
      <div className="text-center" style={{ color: 'yellow', fontSize: '20px' }}>
        {getPatternName(pattern)}
      </div>
      <table className='mb-0 pb-0' style={{ backgroundColor: '#E2E8F0', borderCollapse: 'collapse' }}>
        <thead>
          <tr>{headerCells}</tr>
        </thead>
        <tbody className='mb-0 pb-0'>{rows}</tbody>
      </table>
      </div>
    );
  };

  const sliderContainerStyles = {
    width: '100%',
    maxWidth: '300px',
    margin: '0 auto',
    padding: '0 10px',
    boxSizing: 'border-box'
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const ProfileIcon = ({ onClick }) => {
    return (
      <div className="flex items-center gap-2">
        <div 
          onClick={onClick}
          className="
            w-10 h-8
            rounded-full 
            bg-gradient-to-b from-gray-300 to-gray-400
            flex items-center justify-center
            cursor-pointer
            hover:shadow-lg
            transition-shadow duration-200
          "
        >
          <div className="
            w-9 h-9 
            rounded-full 
            bg-gray-200
            flex items-center justify-center
            overflow-hidden
          ">
            <svg 
              className="w-6 h-6 text-gray-500"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
          </div>
        </div>
      </div>
    );
  };

  const handleProfileClick = () => {
      navigate('/reports')
    };

  const GameTypes = () => {
    return (
      <div className="flex flex-wrap gap-1 items-center px-1 py-1 mb-0 ml-5">
        <button
          onClick={() => handleGameTypeSelect('regular')}
          className={`
            text-md px-1.5 py-1.5 rounded-md transition-colors duration-200 max-h-10 min-h-6
            ${gameType === 'regular' 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }
          `}
        >
          መደበኛ ቢንጎ
        </button>
  
        <button
          onClick={() => handleGameTypeSelect('fast')}
          className={`
            text-md px-1.5 py-1.5 rounded-md transition-colors duration-200 max-h-20 min-h-6
            ${gameType === 'fast' 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }
          `}
        >
          ፈጣን ቢንጎ
        </button>
  
        <button
          onClick={() => handleGameTypeSelect('strategic-six-call')}
          className={`
            text-md px-1.5 py-1.5 rounded-md transition-colors duration-200 max-h-20 min-h-6
            ${gameType === 'strategic-six-call' 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }
          `}
        >
          በጣም ፈጣን ቢንጎ
        </button>

        <button
          onClick={() => handleGameTypeSelect('slow')}
          className={`
            text-md px-1.5 py-1.5 rounded-md transition-colors duration-200 max-h-20 min-h-6
            ${gameType === 'slow' 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }
          `}
        >
          ቀስ ያለ ቢንጎ
        </button>
  
        <button
          onClick={() => handleGameTypeSelect('house')}
          className={` text-md house-button ${gameType === 'house' ? 'active' : ''}`}
        >
          ከኦንላይን ተጫዋቾች ጋር (x2)
          <span className="sparkle"></span>
          <span className="glow"></span>
        </button>
  
        <button
          onClick={() => navigate('/abazh')}
          className={`
            text-md px-1.5 py-1.5 rounded-md transition-colors duration-200 max-h-20 min-h-6
            ${gameType === 'multiplier' 
              ? 'bg-yellow-500 text-white' 
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }
          `}
        >
          አባዥ ቢንጎ
        </button>
        <JackpotGameButton />

        {showJackpotSettings && <JackpotSettingsModal />}
        
        {/* <Button
          onClick={fetchLastFiveGames}
          className="btn btn-info btn-sm max-h-20 min-h-6"
          style={{ marginRight: '10px' }}
        >
          Last 5 Games
        </Button> */}
      </div>
    );
  };

  const clearSelectedNumbers = () => {
    setSelectedNumbers([]);
    localStorage.removeItem('selectedNumbers');
    inputRef.current?.focus();
  };

  const FullScreenButton = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);
  
    const toggleFullScreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().then(() => {
          setIsFullScreen(true);
        });
      } else {
        document.exitFullscreen().then(() => {
          setIsFullScreen(false);
        });
      }
    };
  
    return (
      <button
        onClick={toggleFullScreen}
        className="text-white hover:text-amber-400 transition-colors duration-200"
        title={isFullScreen ? "Exit fullscreen" : "Enter fullscreen"}
      >
        {isFullScreen ? (
          <FaCompress size={20} />
        ) : (
          <FaExpand size={28} />
        )}
      </button>
    );
  };
  
  // Add this useEffect to fetch jackpot info when component mounts
  useEffect(() => {
    const fetchJackpotInfo = async () => {
      try {
        const response = await api.get(`${API}/admin/jackpot-info`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log(response);
        
        setJackpotEnabled(response.jackpotEnabled);
        setJackpotContributionRate(response.jackpotContributionRate);
        setJackpotPool(response.jackpotPool);
      } catch (error) {
        console.error('Error fetching jackpot info:', error);
      }
    };
    
    fetchJackpotInfo();
  }, []);

  // Add this function to handle jackpot settings update
  const handleUpdateJackpotSettings = async () => {
    try {
      const response = await api.post(`${API}/admin/update-jackpot-settings`, {
        jackpotEnabled,
        jackpotContributionRate
      }, );

      setJackpotEnabled(response.jackpotEnabled);
      setJackpotContributionRate(response.jackpotContributionRate);
      setJackpotPool(response.jackpotPool);
      setShowJackpotSettings(false);
      toast.success('Jackpot settings updated successfully');
    } catch (error) {
      console.error('Error updating jackpot settings:', error);
      toast.error('Failed to update jackpot settings');
    }
  };

  // Add this function to start a jackpot game
  const handleStartJackpotGame = async () => {
    setIsLoading(true);
    try {
      const response = await api.post(`${API}/game/start`, {
        bettingAmount: parseInt(bettingAmount),
        cardPaletteNumbers: selectedNumbers,
        callSpeed: parseInt(callSpeed),
        gameType: 'jackpot',
        winningPatterns: JSON.parse(localStorage.getItem('winningPattern')),
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      navigate('/game-in-progress', { 
        state: { 
          gameId: response.gameId, 
          calledNumbers: response.calledNumbers, 
          playingCards: response.playingCards, 
          payoutToWinner: response.payoutToWinner, 
          callSpeed, 
          audioLanguage, 
          gameType: 'jackpot',
          jackpotPool: response.jackpotPool,
          isJackpotGame: true
        } 
      });
    } catch (error) {
      console.error('Error starting jackpot game:', error);
      if (error.response?.status === 400) {
        toast.error(error.response.data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };
  
  const JackpotSettingsModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-96 shadow-xl">
        <h2 className="text-2xl font-bold text-white mb-4">ጃክፖት መመሪያ</h2>
        <div className="mb-4">
          <label className="flex items-center text-white">
            <input
              type="checkbox"
              checked={jackpotEnabled}
              onChange={(e) => setJackpotEnabled(e.target.checked)}
              className="mr-2 h-5 w-5"
            />
            ጃክፖት ያብሩ
          </label>
        </div>
        
        <div className="mb-4">
          <label className="block text-white mb-2">
            መጠን
          </label>
          <select
            value={jackpotContributionRate}
            onChange={(e) => setJackpotContributionRate(parseFloat(e.target.value))}
            className="w-full bg-gray-700 text-white p-2 rounded"
            disabled={!jackpotEnabled}
          >
            <option value="0.05">5%</option>
            <option value="0.10">10%</option>
            <option value="0.15">15%</option>
            <option value="0.20">20%</option>
            <option value="0.25">25%</option>
            <option value="0.35">35%</option>
          </select>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setShowJackpotSettings(false)}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleUpdateJackpotSettings}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );

  const JackpotGameButton = () => { 
    return (
      <div className="bg-gray-800 mb-1 p-0" style={{marginLeft: dashboardVersion === 'v1' ? '6rem' : '0rem'}}>
        <div className="flex items-center justify-between">
          {jackpotEnabled && (
              <div className="d-flex flex-row p-1">
                <div className="flex flex-col mx-2">
                  <span className="text-yellow-400 text-xl font-bold">ጃክፖት: {jackpotPool.toLocaleString()} Birr</span>
                  <span className="text-green-400 text-xs">Rate:{(jackpotContributionRate * 100).toFixed(0)}%</span>
                </div>
                
                
                <Button
                  onClick={handleStartJackpotGame}
                  disabled={jackpotPool < 1 || selectedNumbers.length < 3 || isLoading}
                  className={` mx-1
                    mt-1 py-1
                    ${jackpotPool >= 1 && selectedNumbers.length >= 3 && !isLoading
                      ? 'bg-gradient-to-r from-yellow-500 to-amber-600 text-white hover:from-yellow-600 hover:to-amber-700'
                      : 'bg-gray-600 text-gray-400 cursor-not-allowed'}
                  `}
                >
                  Play Jackpot
                </Button>
              </div>
          )}
          <button
            onClick={() => setShowJackpotSettings(true)}
            className="text-white hover:text-amber-400 transition-colors duration-200"
          >
            <FaCog size={20} />
          </button>
        </div>
    
        
      </div>
    )
  }

  
  return (
    <div style={{backgroundColor: dashboardVersion === 'v1' ? "#242424" : dashboardVersion === 'v2' ? "#111827" : dashboardVersion === 'v3' ? "#374151" : dashboardVersion === 'v4' ? "#fff" : "#06402B"}}>
      <DashboardVersionToggle />
      <ToastContainer />
      <BonusModal />
      {dashboardVersion === 'v1' ? (
      <div className="container-fluid pl-5 100vh" style={{ minHeight: "100vh", width: "95%", backgroundColor: "#242424", marginLeft: '7%', marginRight: '2%'}}>
        <GameTypes />
        <div className="row p-2 mx-4 mb-4">
          <div className="col-8 py-1 px-4" style={{ minHeight: "100vh", backgroundColor: "#141414"}}>
            <div className="row pb-3 text-white">
            <div className="col-lg-12">
              <div className="row pb-1">
                <div className="col-6">
                  <label htmlFor="bettingAmount" className="form-label">
                    Bet Amount
                  </label>
                  <input
                    list="bettingAmountOptions"
                    className="form-control text-white"
                    style={{backgroundColor: '#475569', border: 'none', borderRadius: 0}}
                    value={bettingAmount}
                    onChange={(e) => setBettingAmount(e.target.value)}
                    placeholder="Select or type Bet Amount"
                    onBlur={handleLocalStorage}
                  />
                  <datalist id="bettingAmountOptions">
                    <option value="10"></option>
                    <option value="15"></option>
                    <option value="20"></option>
                    <option value="25"></option>
                    <option value="50"></option>
                    <option value="100"></option>
                    <option value="150"></option>
                    <option value="200"></option>
                  </datalist>
                </div>
                <div className="col-6">
                  <MultiSelectDropdown />
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="row">
                <div className="col-6">
                  <label htmlFor="audioLanguage" className="form-label">
                    Audio Language
                  </label>
                  <select
                    id="audioLanguage"
                    className="form-select text-white"
                    value={audioLanguage}
                    onChange={(e) => setAudioLanguage(e.target.value)}
                    style={{backgroundColor: '#475569', border: 'none', borderRadius: 0}}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">select an option</option>
                    <option value="male">አማርኛ ወንድ</option>
                    <option value="female">አማርኛ ሴት</option>
                    <option value="male1">አማርኛ ወንድ (አንድ ጥሪ)</option>
                    <option value="oromo">Afaan Oromoo</option>
                    <option value="tig">ትግርኛ</option>
                  </select>
                </div>
                <div className="col-6">
                  <label htmlFor="callSpeed" className="form-label">
                    Call Speed
                  </label>
                  <select
                    style={{backgroundColor: '#475569', border: 'none', borderRadius: 0}}
                    id="callSpeed"
                    className="form-select text-white" 
                    value={callSpeed}
                    onChange={(e) => setCallSpeed(e.target.value)}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">Select Call Speed</option>
                    <option value="3000">3 seconds</option>
                    <option value="5000">5 seconds</option>
                    <option value="6000">6 seconds</option>
                    <option value="7000">7 seconds</option>
                    <option value="10000">10 seconds</option>
                    <option value="15000">15 seconds</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className='d-flex gap-3'>
            <ReloadIcon onClick={handleReloadNumbers} />
            <FaTrash
              className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
              size={20}
              onClick={clearSelectedNumbers}
            />
            </div>
            <input
                ref={inputRef}
                type="text"
                value={numberInput}
                onChange={handleNumberInput}
                onKeyPress={handleKeyPress}
                placeholder="Type a number (1-100)"
                className="form-control text-white mx-2"
                style={{
                  backgroundColor: '#475569',
                  border: 'none',
                  borderRadius: 0,
                  maxWidth: '200px'
                }}
              />
          </div>
          <div className="container m-0 p-0" style={{ width: '100%', maxHeight: "400px", overflowY: "scroll", border: '1px solid #94A3B8', borderColor: '#94A3B8', borderRadius: '5px', scrollbarWidth: 'thin', scrollbarColor: '#94A3B8 #141414' }}>
            {Array.from({ length: 10 }, (_, i) => (
              <div key={i} className="row m-0 p-0" style={{fontSize: 20}}>
                {Array.from({ length: 10 }, (_, j) => (
                  <div key={j} className="col-md-1 m-1 ">
                    <button
                      style={{fontSize: 23, color: '#94A3B8', fontWeight: 500}}
                      className={`btn m-0.25 ${
                        selectedNumbers.includes(i * 10 + j + 1) ? 'btn-primary text-white' : ''
                      }`}
                      onClick={() => handleNumberSelect(i * 10 + j + 1)}
                    >
                      {i * 10 + j + 1}
                    </button>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="col-3 px-2 mx-auto d-flex flex-column">
          <div style={sliderContainerStyles}>
            {slideshowTables.length === 1 ? (
              <div className="single-pattern-container">
                {slideshowTables[0]}
              </div>
            ) : (
              <Slider {...settings}>
                {slideshowTables.map((table, index) => (
                  <div key={index} className="pattern-slide">
                    {table}
                  </div>
                ))}
              </Slider>
            )}
          </div>
          {/* <a href="http://pbingo.me/" target="_blank" className="btn btn-info text-white mt-3">
            Play Spin Wheel
          </a> */}
          <button
            className="mt-5 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
            onClick={() => setIsPrintModalOpen(true)}
            disabled={selectedNumbers.length === 0}
          >
            Print Selected Cards
          </button>

          <PrintCardsModal
            isOpen={isPrintModalOpen}
            onClose={() => setIsPrintModalOpen(false)}
            selectedNumbers={selectedNumbers}
          />

          <button
            className="btn btn-warning btn-lg w-100"
            style={{marginTop: '35%'}}
            onClick={handleStartGame}
            disabled={!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading || bettingAmount < 10}
          >
            {isLoading ? 'Creating Game...' : 'Create Game'}
          </button>
        </div>
        <div className="mr-auto d-flex flex-row justify-content-end">
        </div>
      </div>
      </div>
      ): dashboardVersion === 'v2' ? (
        // New dashboard layout (v2)
        <div className="container-fluid" style={{ minHeight: "100vh", backgroundColor: "#111827" }}>
          <div className="row">
            {/* Left sidebar */}
            <div className="col-2 bg-gray-900 min-h-screen p-2">
              <div className="flex flex-col space-y-4">
                <div className="phoenix-logo">
                  <FaCrown className="icon" style={{marginLeft: '40%'}} />
                  <div className="phoenix-text">FAST</div>
                  <div className="bingo-text">BINGO</div>
                </div>
                <div className="flex flex-col space-y-2">
                  <a 
                    onClick={handleProfileClick} 
                    className="text-white px-4 text-decoration-none py-2 rounded-md hover:bg-white/10 transition-all duration-200 flex items-center space-x-2 cursor-pointer"
                  >
                    <FaChartBar className="text-amber-400" />
                    <span>ሪፖርቶች</span>
                  </a>

                  <a 
                    href='http://pbet.site/' 
                    target='_blank' 
                    className="text-white px-4 text-decoration-none py-2 rounded-md hover:bg-white/10 transition-all duration-200 flex items-center space-x-2"
                  >
                    <FaGamepad className="text-amber-400" />
                    <span>ሌሎች ጨዋታዎች</span>
                  </a>

                  <a 
                    href='https://t.me/phoenixbingo' 
                    target='_blank' 
                    className="text-white px-4 text-decoration-none py-2 rounded-md hover:bg-white/10 transition-all duration-200 flex items-center space-x-2"
                  >
                    <FaTelegram className="text-amber-400" />
                    <span>የቴሌግራም ቻናል</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="col-10 p-1">
                <GameTypes />
                <div className="row">
                  <div className="col-8">
                    <div className="bg-gray-900 p-2 rounded-lg mb-2">
                      <div className="row g-3">
                        <div className="d-flex flex-row gap-2" >
                          <div>
                            <label className="text-white mb-1">Bet Amount</label>
                            <input
                              list="bettingAmountOptions"
                              className="form-control text-white p-2"
                              value={bettingAmount}
                              onChange={(e) => setBettingAmount(e.target.value)}
                              placeholder="Select or type Bet Amount"
                              onBlur={handleLocalStorage}
                              style={{backgroundColor: '#475569', border: 'none', borderRadius: 0, marginTop: '5px'}}
                            />
                            <datalist id="bettingAmountOptions">
                              <option value="10" />
                              <option value="15" />
                              <option value="20" />
                              <option value="25" />
                              <option value="50" />
                              <option value="100" />
                              <option value="150" />
                              <option value="200" />
                            </datalist>
                          </div>

                          <div style={{minWidth: '35%'}}>
                            <MultiSelectDropdown />
                          </div>

                          <div style={{minWidth: '35%'}}>
                            <label className="text-white mb-2">Audio Language</label>
                            <select
                              className="form-select p-2 text-white"
                              value={audioLanguage}
                              onChange={(e) => setAudioLanguage(e.target.value)}
                              style={{backgroundColor: '#475569', border: 'none', borderRadius: 0}}
                              onBlur={handleLocalStorage}
                            >
                              <option value="">ቋንቋ ይምረጡ</option>
                              <option value="male">አማርኛ ወንድ</option>
                              <option value="female">አማርኛ ሴት</option>
                              <option value="male1">ወንድ (1 ጠሪ)</option>
                              <option value="tig">ትግርኛ</option>
                              <option value="oromo">Afaan Oromoo</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-800 p-2 rounded-lg">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <div className='d-flex gap-3'>
                        <ReloadIcon onClick={handleReloadNumbers} />
                        <FaTrash
                          className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                          size={20}
                          onClick={clearSelectedNumbers}
                        />
                        </div>
                        <input
                            ref={inputRef}
                            type="text"
                            value={numberInput}
                            onChange={handleNumberInput}
                            onKeyPress={handleKeyPress}
                            placeholder="Type a number (1-100)"
                            className="form-control text-white mx-2"
                            style={{
                              backgroundColor: '#475569',
                              border: 'none',
                              borderRadius: 0,
                              maxWidth: '200px'
                            }}
                        />
                      </div>
                      <div className="grid grid-cols-10 gap-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {Array.from({ length: 100 }, (_, i) => (
                          <button
                            key={i + 1}
                            className={`p-2 rounded text-xl font-medium ${
                              selectedNumbers.includes(i + 1)
                                ? 'bg-purple-500 text-white'
                                : 'bg-gray-700 text-gray-300'
                            }`}
                            onClick={() => handleNumberSelect(i + 1)}
                          >
                            {i + 1}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Pattern preview and actions */}
                  <div className="col-4">
                    <div className="bg-gray-800 p-4 rounded-lg mb-4">
                      <div className="pattern-preview">
                        <Slider {...settings}>
                          {slideshowTables.map((table, index) => (
                            <div key={index}>{table}</div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                    <button
                      className="mt-3 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
                      onClick={() => setIsPrintModalOpen(true)}
                      disabled={selectedNumbers.length === 0}
                    >
                      Print Selected Cards
                    </button>

                    <PrintCardsModal
                      isOpen={isPrintModalOpen}
                      onClose={() => setIsPrintModalOpen(false)}
                      selectedNumbers={selectedNumbers}
                    />
                    {/* Start Game Button */}
                    <button
                      className="btn btn-success btn-lg w-100 mt-4"
                      onClick={handleStartGame}
                      disabled={!bettingAmount  || selectedNumbers.length < 3 || isLoading || bettingAmount < 10}
                    >
                      {isLoading ? 'Creating Game...' : 'Create Game'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      ): dashboardVersion === 'v3' ? (
        <div className="container mx-auto px-2 py-4">
        <div className="grid grid-cols-12 gap-6">
          {/* Left Column */}
          <div className="col-span-8">
            <div className="bg-gray-800 rounded-lg p-4 shadow-lg">
              {/* Settings Grid */}
              <div className="grid grid-cols-2 gap-2 mb-6">
                <div>
                  <label className="block text-white mb-2">Bet Amount</label>
                  <input
                    list="bettingAmountOptions"
                    className="w-full p-2 bg-gray-700 text-white rounded-lg"
                    value={bettingAmount}
                    onChange={(e) => setBettingAmount(e.target.value)}
                    placeholder="Select or type Bet Amount"
                    onBlur={handleLocalStorage}
                  />
                  <datalist id="bettingAmountOptions">
                    <option value="10" />
                    <option value="15" />
                    <option value="20" />
                    <option value="25" />
                    <option value="50" />
                    <option value="100" />
                    <option value="150" />
                    <option value="200" />
                  </datalist>
                </div>

                <div>
                  <MultiSelectDropdown />
                </div>

                <div>
                  <label className="block text-white mb-2">Audio Language</label>
                  <select
                    className="w-full p-2 bg-gray-700 text-white rounded-lg"
                    value={audioLanguage}
                    onChange={(e) => setAudioLanguage(e.target.value)}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">select an option</option>
                    <option value="male">Amharic Male</option>
                    <option value="female">Amharic Female</option>
                    <option value="male1">Male (1 teri)</option>
                    <option value="oromo">Afaan Oromoo</option>
                  </select>
                </div>
                <div>
                  <label className="block text-white mb-2">Call Speed</label>
                  <select
                    className="w-full p-2 bg-gray-700 text-white rounded-lg"
                    value={callSpeed}
                    onChange={(e) => setCallSpeed(e.target.value)}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">Select Call Speed</option>
                    <option value="5000">5 seconds</option>
                    <option value="6000">6 seconds</option>
                    <option value="7000">7 seconds</option>
                    <option value="10000">10 seconds</option>
                    <option value="15000">15 seconds</option>
                  </select>
                </div>
              </div>

              {/* Numbers Grid */}
              <div className="mt-6">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <div className='d-flex gap-3'>
                  <ReloadIcon onClick={handleReloadNumbers} />
                  <FaTrash
                    className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                    size={20}
                    onClick={clearSelectedNumbers}
                  />
                  </div>
                  <input
                      ref={inputRef}
                      type="text"
                      value={numberInput}
                      onChange={handleNumberInput}
                      onKeyPress={handleKeyPress}
                      placeholder="Type a number (1-100)"
                      className="form-control text-white mx-2"
                      style={{
                        backgroundColor: '#475569',
                        border: 'none',
                        borderRadius: 0,
                        maxWidth: '200px'
                      }}
                    />
                </div>
                <div className="grid grid-cols-10 gap-2">
                  {Array.from({ length: 100 }, (_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => handleNumberSelect(i + 1)}
                      className={`
                        p-2 text-xl font-medium rounded-lg
                        transition-all duration-200
                        ${selectedNumbers.includes(i + 1)
                          ? 'bg-purple-600 text-white shadow-lg'
                          : 'bg-gray-700 text-gray-400 hover:bg-gray-600'
                        }
                      `}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg d-flex flex-column justify-content-center align-items-center">
              <div className="pattern-preview mb-8">
                <Slider {...settings}>
                  {slideshowTables.map((table, index) => (
                    <div key={index}>{table}</div>
                  ))}
                </Slider>
              </div>
              <button
                className="mb-3 bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 w-full py-2 rounded-lg font-bold text-lg w-75 d-flex justify-content-center
                  transition-all duration-200"
                onClick={() => setIsPrintModalOpen(true)}
                disabled={selectedNumbers.length === 0}
              >
                Print Selected Cards
              </button>

              <PrintCardsModal
                isOpen={isPrintModalOpen}
                onClose={() => setIsPrintModalOpen(false)}
                selectedNumbers={selectedNumbers}
              />

              <button
                onClick={handleStartGame}
                disabled={!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading}
                className={`
                  w-full py-2 rounded-lg font-bold text-lg w-75 d-flex justify-content-center
                  transition-all duration-200
                  ${!isLoading && bettingAmount && callSpeed && selectedNumbers.length >= 3
                    ? 'bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600'
                    : 'bg-gray-600 cursor-not-allowed'
                  }
                  text-white shadow-lg
                `}
              >
                {isLoading ? 'Creating Game...' : 'Create Game'}
              </button>
            </div>
          </div>
        </div>
      </div>
      ): dashboardVersion === 'v4' ? (
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-8">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <div className="grid grid-cols-2 gap-6 mb-2">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Bet Amount
                  </label>
                  <div className="relative">
                    <input
                      list="bettingAmountOptions"
                      className="w-full px-3 py-2 bg-gray-50 text-gray-800 rounded-lg border border-gray-200"
                      value={bettingAmount}
                      onChange={(e) => setBettingAmount(e.target.value)}
                      placeholder="Select or type Bet Amount"
                      onBlur={handleLocalStorage}
                    />
                    <datalist id="bettingAmountOptions">
                      {[10, 15, 20, 25, 50, 100, 150, 200].map(value => (
                        <option key={value} value={value} />
                      ))}
                    </datalist>
                  </div>
                </div>
                <div>
                  <MultiSelectDropdownLight/>
                </div>
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Audio Language
                  </label>
                  <select
                    className="w-full p-2 bg-gray-50 text-gray-800 rounded-lg border border-gray-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-200 transition-all duration-200"
                    value={audioLanguage}
                    onChange={(e) => setAudioLanguage(e.target.value)}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">Select Language</option>
                    <option value="male">Amharic Male</option>
                    <option value="female">Amharic Female</option>
                    <option value="male">English Male</option>
                    <option value="female">English Female</option>
                    <option value="oromo">Afaan Oromoo</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Call Speed
                  </label>
                  <select
                    className="w-full p-2 bg-gray-50 text-gray-800 rounded-lg border border-gray-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-200 transition-all duration-200"
                    value={callSpeed}
                    onChange={(e) => setCallSpeed(e.target.value)}
                    onBlur={handleLocalStorage}
                  >
                    <option value="">Select Speed</option>
                    {[5000, 6000, 7000, 10000, 15000].map(value => (
                      <option key={value} value={value}>
                        {value / 1000} seconds
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className='d-flex gap-3'>
                      <ReloadIcon onClick={handleReloadNumbers} />
                      <FaTrash
                        className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                        size={20}
                        onClick={clearSelectedNumbers}
                      />
                    </div>
                    <input
                        ref={inputRef}
                        type="text"
                        value={numberInput}
                        onChange={handleNumberInput}
                        onKeyPress={handleKeyPress}
                        placeholder="Type a number (1-100)"
                        className="form-control text-white mx-2"
                        style={{
                          backgroundColor: '#eee',
                          border: 'none',
                          borderRadius: 0,
                          maxWidth: '200px'
                        }}
                    />
                  </div>
                <div className="grid grid-cols-10 gap-2">
                  {Array.from({ length: 100 }, (_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => handleNumberSelect(i + 1)}
                      className={`
                         p-2 text-lg font-medium rounded-lg
                        transition-all duration-200
                        ${selectedNumbers.includes(i + 1)
                          ? 'bg-gradient-to-r from-amber-400 to-yellow-500 text-white shadow-md transform scale-105'
                          : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:shadow-md'
                        }
                      `}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-4">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <div className="pattern-preview mb-8">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <Slider {...settings}>
                    {slideshowTables.map((table, index) => (
                      <div key={index}>{table}</div>
                    ))}
                  </Slider>
                </div>
              </div>

              <button
                className="mb-2 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
                onClick={() => setIsPrintModalOpen(true)}
                disabled={selectedNumbers.length === 0}
              >
                Print Selected Cards
              </button>

              <PrintCardsModal
                isOpen={isPrintModalOpen}
                onClose={() => setIsPrintModalOpen(false)}
                selectedNumbers={selectedNumbers}
              />

              <button
                onClick={handleStartGame}
                disabled={!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading}
                className={`
                  w-full py-4 rounded-lg font-bold text-lg
                  transition-all duration-300
                  ${!isLoading && bettingAmount && callSpeed && selectedNumbers.length >= 3
                    ? 'bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-white shadow-lg transform hover:scale-105'
                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  }
                `}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Creating Game...
                  </span>
                ) : (
                  'Create Game'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      ):dashboardVersion === 'v5' ? (
        <div className="animated-gradient relative">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-1/2 -left-1/2 w-full h-full rounded-full bg-purple-500 opacity-20 blur-3xl"></div>
            <div className="absolute top-1/2 -right-1/2 w-full h-full rounded-full bg-blue-500 opacity-20 blur-3xl"></div>
            <div className="absolute -bottom-1/2 left-1/2 w-full h-full rounded-full bg-teal-500 opacity-20 blur-3xl"></div>
          </div>

          <div className="relative mx-auto p-4">
            <div className="grid grid-cols-12 gap-4">
              {/* Left Settings Panel */}
              <div className="col-span-3">
                <div className="glass-morphism p-6 h-full">
                  <h2 className="text-white text-xl font-light mb-6 tracking-wider">Game Controls</h2>
                  <div className="space-y-3">
                    
                    <GlassMultiSelectDropdown className="w-full px-4 py-2 glass-button text-white"/>
                    <div className="glass-card p-2">
                      <label className="block text-white/80 text-sm mb-2">Betting Amount</label>
                      <input
                        type="text"
                        value={bettingAmount}
                        onChange={(e) => setBettingAmount(e.target.value)}
                        className="w-full px-4 py-2 glass-button text-white placeholder-white/50"
                        placeholder="Enter amount"
                      />
                    </div>

                    <div className="glass-card p-2">
                      <label className="block text-white/80 text-sm mb-2">Voice Selection</label>
                      <select
                        value={audioLanguage}
                        onChange={(e) => setAudioLanguage(e.target.value)}
                        className="w-full px-4 py-2 glass-button bg-gray-700 text-white"
                      >
                        <option value="" className="text-black bg-gray-200">Choose Voice</option>
                        <option value="male" className="text-black bg-gray-200">Amharic Male</option>
                        <option value="female" className="text-black bg-gray-300/10">Amharic Female</option>
                        <option value="oromo" className="text-black bg-gray-300/10">Afaan Oromoo</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Center Numbers Grid */}
              <div className="col-span-6">
                <div className="glass-morphism p-6">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className='d-flex gap-3'>
                    <ReloadIcon onClick={handleReloadNumbers} />
                    <FaTrash
                      className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                      size={20}
                      onClick={clearSelectedNumbers}
                    />
                    </div>
                    <input
                        ref={inputRef}
                        type="text"
                        value={numberInput}
                        onChange={handleNumberInput}
                        onKeyPress={handleKeyPress}
                        placeholder="Type a number (1-100)"
                        className="form-control text-white mx-2 animated-gradient relative"
                        style={{
                          border: 'none',
                          borderRadius: 0,
                          maxWidth: '200px'
                        }}
                      />
                  </div>
                  <div className="grid grid-cols-10 gap-2 mt-1">
                    {Array.from({ length: 100 }, (_, i) => (
                      <button
                        key={i + 1}
                        onClick={() => handleNumberSelect(i + 1)}
                        className={`
                          aspect-square rounded-xl text-lg font-light
                          transition-all duration-300 transform hover:scale-110
                          ${selectedNumbers.includes(i + 1)
                            ? 'bg-gradient-to-br from-purple-500/80 to-blue-500/80 text-white shadow-lg'
                            : 'glass-button text-white hover:text-white/90'
                          }
                        `}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Pattern Display */}
              <div className="col-span-3">
                <div className="glass-morphism p-3 h-full">
                  <div className="mb-2">
                    <h2 className="text-white text-xl font-light mb-4 tracking-wider">Winning Patterns</h2>
                    <div className="glass-card rounded-xl p-2">
                      <Slider {...settings}>
                        {slideshowTables.map((table, index) => (
                          <div key={index}>{table}</div>
                        ))}
                      </Slider>
                    </div>
                  </div>

              <button
                className="mb-2 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
                onClick={() => setIsPrintModalOpen(true)}
                disabled={selectedNumbers.length === 0}
              >
                Print Selected Cards
              </button>

              <PrintCardsModal
                isOpen={isPrintModalOpen}
                onClose={() => setIsPrintModalOpen(false)}
                selectedNumbers={selectedNumbers}
              />
                  <button
                    onClick={handleStartGame}
                    disabled={!bettingAmount || selectedNumbers.length < 3 || isLoading}
                    className={`
                      w-full py-4 rounded-xl font-light text-lg tracking-wider
                      transition-all duration-500 transform hover:scale-105
                      ${!isLoading && bettingAmount && callSpeed && selectedNumbers.length >= 3
                        ? 'bg-gradient-to-r from-purple-500/80 to-blue-500/80 text-white shadow-lg hover:shadow-2xl'
                        : 'glass-button text-white/50 cursor-not-allowed'
                      }
                    `}
                  >
                    {isLoading ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="animate-spin w-5 h-5 border-2 border-white/20 border-t-white/90 rounded-full"/>
                        <span>Initializing...</span>
                      </span>
                    ) : (
                      'Launch Game'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ):dashboardVersion === 'v6' ? (
        <div style={tropicalParadiseStyles.container} className="tropical-paradise">
          <div style={tropicalParadiseStyles.overlay} />
          <div className="floating-elements">
            {Array.from({ length: 10 }).map((_, i) => (
              <img
                key={i}
                src={`/tropical-element-${i + 1}.svg`}
                className="absolute palm-leaf"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  width: `${30 + Math.random() * 50}px`,
                  opacity: 0.1,
                  transform: `rotate(${Math.random() * 360}deg)`,
                }}
                alt=""
              />
            ))}
          </div>
          <div className="mx-auto p-6">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-3">
                <div style={tropicalParadiseStyles.card} className="paradise-card">
                  <h2 className="text-2xl font-bold mb-4 text-gradient">
                    Fast Bingo
                  </h2>
                  
                  <div className="space-y-6">
                    <div className="relative">
                      <label className="block text-teal-800 mb-2 font-medium">
                        Bet Amount
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
                          🐚
                        </span>
                        <input
                          type="text"
                          value={bettingAmount}
                          onChange={(e) => setBettingAmount(e.target.value)}
                          className="w-full pl-10 pr-4 py-3 rounded-xl bg-white/50 
                                  focus:ring-2 focus:ring-teal-400 transition-all duration-300"
                          placeholder="Enter amount"
                        />
                      </div>
                    </div>

                    <div className="relative">
                      <label className="block text-teal-800 mb-2 font-medium">
                        Select Voice 🌊
                      </label>
                      <select
                        value={audioLanguage}
                        onChange={(e) => setAudioLanguage(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl bg-white/50 
                                focus:ring-2 focus:ring-teal-400 transition-all duration-300"
                      >
                        <option value="">Choose your paradise voice</option>
                        <option value="male">Amharic Male 🏝️</option>
                        <option value="female">Amharic Female 🌺</option>
                        <option value="oromo">Afaan Oromoo 🌴</option>
                      </select>
                    </div>

                    <div className="relative">
                      <label className="block text-teal-800 mb-2 font-medium">
                        Speed ☀️
                      </label>
                      <select
                        value={callSpeed}
                        onChange={(e) => setCallSpeed(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl bg-white/50 
                                focus:ring-2 focus:ring-teal-400 transition-all duration-300"
                      >
                        <option value="">Select your rhythm</option>
                        <option value="5000">Gentle Breeze (5s)</option>
                        <option value="6000">Ocean Waves (6s)</option>
                        <option value="7000">Palm Swaying (7s)</option>
                        <option value="10000">Island Time (10s)</option>
                        <option value="15000">Lazy Sunset (15s)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-6">
                <div style={tropicalParadiseStyles.card} className="numbers-grid">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className='d-flex gap-3'>
                    <ReloadIcon onClick={handleReloadNumbers} />
                    <FaTrash
                      className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                      size={20}
                      onClick={clearSelectedNumbers}
                    />
                    </div>
                    <input
                        ref={inputRef}
                        type="text"
                        value={numberInput}
                        onChange={handleNumberInput}
                        onKeyPress={handleKeyPress}
                        placeholder="Type a number (1-100)"
                        className="form-control text-white mx-2"
                        style={{
                          backgroundColor: '#eef',
                          border: 'none',
                          borderRadius: 0,
                          maxWidth: '200px'
                        }}
                      />
                  </div>
                  <div className="grid grid-cols-10 gap-2">
                    {Array.from({ length: 100 }, (_, i) => (
                      <button
                        key={i + 1}
                        onClick={() => handleNumberSelect(i + 1)}
                        className={`tropical-number aspect-square text-lg font-bold
                                  ${selectedNumbers.includes(i + 1) ? 'selected-number' : ''}`}
                        style={selectedNumbers.includes(i + 1) ? 
                          tropicalParadiseStyles.selectedNumber : 
                          tropicalParadiseStyles.numberButton}
                      >
                        {i + 1}
                        <div className="shine" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Pattern Display with Island Theme */}
              <div className="col-span-3">
                <div style={tropicalParadiseStyles.card} className="pattern-display">
                  <h3 className="text-2xl font-bold mb-2 text-teal-800">
                    Fast Games 🏝️
                  </h3>
                  
                  <div className="pattern-slider mb-8">
                    <Slider {...settings}>
                      {slideshowTables.map((table, index) => (
                        <div key={index} className="p-2 pattern-slide">
                          {table}
                        </div>
                      ))}
                    </Slider>
                  </div>

                  <button
                    className="mb-3 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
                    onClick={() => setIsPrintModalOpen(true)}
                    disabled={selectedNumbers.length === 0}
                  >
                    Print Selected Cards
                  </button>

                  <PrintCardsModal
                    isOpen={isPrintModalOpen}
                    onClose={() => setIsPrintModalOpen(false)}
                    selectedNumbers={selectedNumbers}
                  />

                  <button
                    onClick={handleStartGame}
                    disabled={!bettingAmount || selectedNumbers.length < 3 || isLoading}
                    style={tropicalParadiseStyles.startButton}
                    className="start-game-button"
                  >
                    {isLoading ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="animate-spin w-6 h-6 border-2 border-white border-t-transparent rounded-full" />
                        <span>Creating Paradise...</span>
                      </span>
                    ) : (
                      <>
                        Start 🌴
                        <div className="shine" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ): dashboardVersion === 'v7' ? (
        <div style={underwaterStyles.container} className="underwater-casino">
          <div style={underwaterStyles.caustics} />
          <BubbleGenerator />
          <div className=" mx-auto p-8 relative z-10">
            <div className="grid grid-cols-12 gap-8">
              <div className="col-span-3">
                <div style={underwaterStyles.card}>
                  <h2 className="text-3xl font-bold mb-6 text-cyan-400 text-glow">
                    Fast Bingo
                  </h2>
                  
                  <MultiSelectDropdown />
                  <div className="space-y-6 mt-2">
                    <div className="relative">
                      <label className="block text-cyan-400 mb-2 font-medium">
                        Bet Amount 🦪
                      </label>
                      <input
                        type="text"
                        value={bettingAmount}
                        onChange={(e) => setBettingAmount(e.target.value)}
                        style={underwaterStyles.input}
                        placeholder="Enter bet amount"
                      />
                    </div>

                    <div className="relative">
                      <label className="block text-cyan-400 mb-2 font-medium">
                        Voice 🌊
                      </label>
                      <select
                        value={audioLanguage}
                        onChange={(e) => setAudioLanguage(e.target.value)}
                        style={underwaterStyles.input}
                      >
                        <option value="">Select voice</option>
                        <option value="male">Amharic (Male)</option>
                        <option value="female">Amharic (Female)</option>
                        <option value="oromo">Afaan Oromoo</option>
                      </select>
                    </div>

                  </div>
                </div>
              </div>

              {/* Numbers Grid */}
              <div className="col-span-6">
                <div style={underwaterStyles.card}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <div className='d-flex gap-3'>
                    <ReloadIcon onClick={handleReloadNumbers} />
                    <FaTrash
                      className="reload-icon cursor-pointer text-red-500 hover:text-red-600 transition-colors"
                      size={20}
                      onClick={clearSelectedNumbers}
                    />
                    </div>
                    <input
                        ref={inputRef}
                        type="text"
                        value={numberInput}
                        onChange={handleNumberInput}
                        onKeyPress={handleKeyPress}
                        placeholder="Type a number (1-100)"
                        className="form-control text-white mx-2"
                        style={{
                          backgroundColor: '#475569',
                          border: 'none',
                          borderRadius: 0,
                          maxWidth: '200px',
                          color: 'white'
                        }}
                      />
                  </div>
                  <div className="grid grid-cols-10 gap-2">
                    {Array.from({ length: 100 }, (_, i) => (
                      <button
                        key={i + 1}
                        onClick={() => handleNumberSelect(i + 1)}
                        className={`aspect-square text-lg font-bold relative
                                  ${selectedNumbers.includes(i + 1) ? 'number-glow' : ''}`}
                        style={selectedNumbers.includes(i + 1) ? 
                          underwaterStyles.selectedNumber : 
                          underwaterStyles.numberButton}
                      >
                        {i + 1}
                        {selectedNumbers.includes(i + 1) && <BubbleEffect />}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Pattern Display */}
              <div className="col-span-3">
                <div style={underwaterStyles.card}>
                  <h3 className="text-2xl font-bold mb-4 text-cyan-400 text-glow">
                    Fast Games 🐠
                  </h3>
                  
                  <div className="pattern-slider mb-8">
                    <Slider {...settings}>
                      {slideshowTables.map((table, index) => (
                        <div key={index} className="p-2 underwater-pattern">
                          {table}
                        </div>
                      ))}
                    </Slider>
                  </div>

                  <button
                    className="mb-2 w-full py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 focus:outline-none"
                    onClick={() => setIsPrintModalOpen(true)}
                    disabled={selectedNumbers.length === 0}
                  >
                    Print Selected Cards
                  </button>

                  <PrintCardsModal
                    isOpen={isPrintModalOpen}
                    onClose={() => setIsPrintModalOpen(false)}
                    selectedNumbers={selectedNumbers}
                  />
                  <button
                    onClick={handleStartGame}
                    disabled={!bettingAmount || selectedNumbers.length < 3 || isLoading}
                    className={`
                      w-full py-4 px-6 rounded-lg font-bold text-lg
                      ${(!bettingAmount || selectedNumbers.length < 3 || isLoading)
                        ? 'bg-gray-600 cursor-not-allowed'
                        : 'bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-500 hover:to-blue-600'}
                      text-white relative overflow-hidden transition-all duration-300
                    `}
                  >
                    {isLoading ? (
                      <span className="flex items-center justify-center space-x-2">
                        <div className="animate-spin w-6 h-6 border-2 border-white border-t-transparent rounded-full" />
                        <span>Diving Deep...</span>
                      </span>
                    ) : (
                      'Start Adventure 🐋'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ): dashboardVersion === 'v8' ? (
        <div className="min-h-screen bg-gray-900">
          <div className="bg-gray-800 p-4 sticky top-0 z-50 shadow-lg">
            <div className="flex justify-between items-center">
              <div className="text-white font-bold flex items-center gap-2">
                <FaCrown className="text-yellow-500" />
                <span>Phoenix Bingo</span>
              </div>
              <ProfileIcon onClick={handleProfileClick} className="text-end"/>
            </div>
          </div>
          <div className="d-none p-4 space-y-4">
            {/* Game Settings */}
            <div className="bg-gray-800 rounded-lg p-4 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-gray-400 text-sm block mb-1">Bet Amount</label>
                  <input
                    type="number"
                    value={bettingAmount}
                    onChange={(e) => setBettingAmount(e.target.value)}
                    className="w-full bg-gray-700 text-white rounded p-2 text-lg"
                    placeholder="Enter amount"
                  />
                </div>
                <div>
                  <label className="text-gray-400 text-sm block mb-1">Voice</label>
                  <select
                    value={audioLanguage}
                    onChange={(e) => setAudioLanguage(e.target.value)}
                    className="w-full bg-gray-700 text-white rounded p-2 text-lg"
                  >
                    <option value="">Select voice</option>
                    <option value="male">Amharic Male</option>
                    <option value="female">Amharic Female</option>
                    <option value="oromo">Afaan Oromoo</option>
                  </select>
                </div>
              </div>

              {/* Pattern Selector */}
              <div className="mobile-pattern-selector">
                <MultiSelectDropdown />
              </div>
            </div>

            {/* Numbers Grid */}
            <div className="bg-gray-800 rounded-lg p-4">
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-gray-400 text-sm">Select Numbers</h3>
                <ReloadIcon onClick={handleReloadNumbers} />
              </div>
              <div className="grid grid-cols-5 gap-2">
                {Array.from({ length: 100 }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => handleNumberSelect(i + 1)}
                    className={`
                      aspect-square rounded-lg text-lg font-bold
                      flex items-center justify-center
                      ${selectedNumbers.includes(i + 1)
                        ? 'bg-gradient-to-r from-purple-500 to-blue-500 text-white'
                        : 'bg-gray-700 text-gray-300'
                      }
                    `}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </div>

            {/* Start Game Button - Fixed at Bottom */}
            <div className="fixed bottom-0 left-0 right-0 p-4 bg-gray-900">
              <button
                onClick={handleStartGame}
                disabled={!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading}
                className={`
                  w-full py-4 rounded-lg text-lg font-bold
                  ${(!bettingAmount || !callSpeed || selectedNumbers.length < 3 || isLoading)
                    ? 'bg-gray-700 text-gray-500'
                    : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white'
                  }
                `}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center gap-2">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Creating Game...
                  </span>
                ) : (
                  'Start Game'
                )}
              </button>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <h3 className="text-gray-400 text-sm mb-2">Winning Pattern</h3>
              <div className="pattern-preview">
                <Slider {...settings}>
                  {slideshowTables.map((table, index) => (
                    <div key={index} className="px-2">
                      {table}
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div> 
          <div className="p-4">
            <div className="bg-gray-800 rounded-lg p-6 text-center">
              <div className="flex flex-col items-center space-y-4">
                <div className="flex space-x-3 text-gray-400">
                  <FaMobile className="text-3xl" />
                  <FaVolumeUp className="text-3xl" />
                </div>
                
                <h2 className="text-xl font-medium text-white">
                  በቅርብ ጊዜ የሚመጣ
                </h2>
                
                <p className="text-gray-400">
                  ስፒከር እና ሞባይል ስልክ ብቻ የሚጠይቅ የሞባይል ቨርዥን በቅርቡ ይመጣል።
                </p>

                <div className="animate-pulse mt-4">
                  <div className="flex items-center space-x-2 text-amber-400">
                    <FaClock />
                    <span>በቅርቡ</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      ):(
        <div>
        </div>
    )}
    {/* <NewGamesAnnouncementPopup /> */}
    <Modal show={showGameHistory} variant="dark" onHide={() => setShowGameHistory(false)}>
      <Modal.Header closeButton>
        <Modal.Title>የመጨረሻ 5 ጨዋታዎች ታሪክ</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped dark hover>
          <thead>
            <tr>
              <th>ቀን</th>
              <th>መደብ</th>
              <th>ሁኔታ</th>
              <th>ደራሽ</th>
            </tr>
          </thead>
          <tbody>
            {lastGames.slice(0, 5).map((game) => (
              <tr key={game._id}>
                <td>{new Date(game.createdAt).toLocaleString()}</td>
                <td>{game.bettingAmount} Birr</td>
                <td>{game.status === 'finished' ? 'ተጠናቋል' : 
                  game.status === 'pending' ? 'አልተጠናቀቀም' : game.status}
               </td>
                <td>{game.payoutToWinner} Birr</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
    </div>
  );
}

export default DashboardPage;
